<template>
    <div>
        <a-modal :width="700" :visible="visible" v-show="visible" @cancel="handleCancel">
            <div style="display: flex; gap: 10px">
                <div>
                    <SupsisIcon style="width: 50px; height: 50px" />
                </div>
                <div>
                    <div class="ant-modal-title">What's New</div>
                    <p>New features, bug fixes, and content you might've missed.</p>
                </div>
            </div>

            <div class="news-modal-body">
                <ItemNewsModal
                    v-for="(item, index) in newsItems"
                    :key="index"
                    :title="item.title"
                    :ticket="item.ticket"
                    :description="item.description"
                    :newsLink="item.newsLink"
                    :date="item.date"
                    :linkText="item.linkText"
                    :ribbonText="item.ribbonText"
                    :on-click="item.onClick"
                    :on-clicked="handleCancel"
                />
            </div>
            <template #footer>
                <a-button @click="handleCancel">{{ $t("message.close") }}</a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import ItemNewsModal from "./ItemNewsModal.vue";
import SupsisIcon from "../../views/Pages/Chatbot/pages/integrations/svg/SupsisIcon.vue";
import moment from "moment";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";

export default {
    name: "NewsModal",
    components: {
        ItemNewsModal,
        SupsisIcon,
    },
    data() {
        return {
            visible: false,
            appVersion: "30", // Her yeni bir duyuru eklendiğinde bu versiyonu bir arttırın.
            lastSeenVersion: null,
            newsItems: [
            {
                    title: "⭐️ Yeni sürümde neler yapıldı?",
                    ticket: "UI Update",
                    description:
                        "⭐️ Ticket sayfasına detaylı filtreler , listeler , ve sesli assistant eklendi." +
                        "⭐️ Task ve Rezervsyon bildirimleri alakasız kişilerde gözükmesi engellendi.<br/>" +
                        "⭐️ Chat sayfasında solda artık contact propertiesleride göreceksiniz.<br/>" +
                        "⭐️ Rezervasyon güncelleme ve silme özelliği eklendi. Karşı tarafa eposta ile bilgilendirme eklendi.<br/>" ,
                    date: moment("2024-09-16").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Güncellemeler",
                },
                {
                    title: "⭐️ Yeni Chat Ekranda İyileştirmeler Yapıldı",
                    ticket: "UI Update",
                    description:
                        "⭐️ Default filtre 'canlı destek' oldu sisteme gelen tüm chatleri bu ekranda göreceksiniz" +
                        "⭐️ Sohhet sıralama özelliği eklendi default yeni chatler üstte olacak.<br/>" +
                        "⭐️ Kişilerinizi gruplayabilirsiniz. Hangi kişi veya hangi departman yönetiyor gruplu bir şekilde göreceksiniz.<br/>" +
                        "⭐️ Çoklu chat izleme ekranı eklendi. Aynı anda bir den çok chati canlı canlı izleyebileceksiniz.<br/>" +
                        "⭐️ Grup filtreleme özelliği eklendi.<br/>" +
                        "⭐️ Hazır listelerde filtre seçme zorunluluğu kaldı sadece özel modda filtreler ekleyebileceksiniz" +
                        "⭐️ Kuyrukta bekleyen veya chatbotta olanları hızlıca göreceğiniz sekmeler ekledik.<br/>",
                    date: moment("2024-09-02").format("YYYY-MM-DD"),
                    ribbonText: "UI Güncellemesi",
                    newsLink: "Yeni Chat Ekranını Keşfetmek İçin Tıklayın",
                    linkText: "chat",
                },
                // yeni bir duyuru eklemek için aşağıdaki objeyi kopyalayın ve içeriğini doldurun ve yeni eklenen objeyi en alta değil en üstüne olacak şekilde ekleyin.
                // {
                //     title: "📝 Yeni Form Özelliği 📝",
                //     ticket: "New Feature",
                //     description:
                //         "📝 Artık kullanıcılar kendi formlarını oluşturabilir ve web sitelerine entegre edebilirler.<br/>" +
                //         "📝 Müşterilere anında form gönderebilme özelliği eklendi.<br/>" +
                //         "📝 Formlar aracılığıyla müşteri bilgileri toplanabilir ve anketler düzenlenebilir.<br/>" +
                //         "📝 Formların tasarımı ve içerikleri tamamen özelleştirilebilir.<br/>" +
                //         "📝 Form sonuçları anlık olarak takip edilebilir ve analiz edilebilir.<br/>",
                //     date: moment("2024-08-23").format("YYYY-MM-DD"),
                //     ribbonText: "Yeni Özellik",
                //     newsLink: "Form Özelliğini Keşfetmek İçin Tıklayın",
                //     linkText: "form",
                // },
                // {
                //     title: "🤖 Yeni Otomasyon Özelliği 🤖",
                //     ticket: "New Feature",
                //     description:
                //         "🤖 Artık işlemlerinizde insan müdahalesini minimuma indirerek tüm süreçleri otomasyonla yönetebilirsiniz.<br/>" +
                //         "🤖 Müşteri etkileşimlerini otomatikleştirin: Örneğin, müşteri geldiğinde otomatik olarak bir e-posta gönderin, yanıt bekleyin, belirli bir süre sonra tekrar müşteriye hatırlatma yapın gibi hayal ettiğiniz tüm senaryoları gerçekleştirin.<br/>" +
                //         "🤖 İş akışlarınızı tamamen özelleştirin ve tekrarlayan görevleri otomatikleştirerek zaman kazanın.<br/>" +
                //         "🤖 Müşteri takibi, e-posta gönderimi, hatırlatmalar ve daha fazlası artık otomatik olarak yönetilebilir.<br/>" +
                //         "🤖 Otomasyon sayesinde iş süreçlerinizi hızlandırın ve verimliliği artırın.<br/>",
                //     date: moment("2024-08-23").format("YYYY-MM-DD"),
                //     ribbonText: "Yeni Özellik",
                //     newsLink: "Otomasyon Özelliğini Keşfetmek İçin Tıklayın",
                //     linkText: "automations/all-automations",
                // },
                {
                    title: "💬 Yeni Chat Ekranı Tasarımı 💬",
                    ticket: "UI Update",
                    description:
                        "💬 Chat ekranı tamamen yenilendi! Artık daha modern, kullanışlı ve estetik bir arayüz ile sohbet deneyiminizi iyileştirin.<br/>" +
                        "💬 Sohbet penceresi daha akıcı ve kullanıcı dostu bir tasarıma kavuştu.<br/>" +
                        "💬 Mesajlar arasında gezinme ve yanıt verme işlemleri daha hızlı ve kolay hale getirildi.<br/>" +
                        "💬 Yenilenen arayüz ile birlikte sohbet geçmişine erişim ve yönetim daha pratik bir hale geldi.<br/>" +
                        "💬 Kullanıcı deneyimini artırmak için çeşitli görsel iyileştirmeler ve performans geliştirmeleri yapıldı.<br/>",
                    date: moment("2024-08-23").format("YYYY-MM-DD"),
                    ribbonText: "UI Güncellemesi",
                    newsLink: "Yeni Chat Ekranını Keşfetmek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "👥 Yeni Ziyaretçi Tasarımı 👥",
                    ticket: "UI Update",
                    description:
                        "👥 Ziyaretçi arayüzü tamamen yenilendi! Artık daha modern ve güncel bir tasarımla ziyaretçilerinizi karşılayın.<br/>" +
                        "👥 Sohbet balonu tasarımı, önceki sürüme göre daha şık ve kullanıcı dostu olacak şekilde yeniden tasarlandı.<br/>" +
                        "👥 Ziyaretçi arayüzü, daha sezgisel bir deneyim sunmak için optimize edildi.<br/>" +
                        "👥 Ziyaretçilerinizi etkilemek ve etkileşimlerini artırmak için görsel iyileştirmeler yapıldı.<br/>" +
                        "👥 Yeni tasarım ile birlikte ziyaretçilerinizle olan iletişiminizi daha etkili ve estetik bir şekilde yönetin.<br/>",
                    date: moment("2024-08-23").format("YYYY-MM-DD"),
                    ribbonText: "UI Güncellemesi",
                    newsLink: "Yeni Ziyaretçi Tasarımını Keşfetmek İçin Tıklayın",
                    linkText: "settings/theme-settings",
                },
                {
                    title: "📱 Yeni Mobil Uygulama Tasarımı 📱",
                    ticket: "App Update",
                    description:
                        "📱 Mobil uygulamamızın tasarımı tamamen yenilendi! Artık daha modern ve kullanıcı dostu bir arayüz ile mobil deneyiminizi geliştirin.<br/>" +
                        "📱 Uygulamanın genel performansı artırıldı ve kullanım kolaylığı sağlandı.<br/>" +
                        "📱 Mobil uygulamadaki çeşitli hatalar düzeltildi ve daha stabil bir deneyim sunulması sağlandı.<br/>" +
                        "📱 Yeni tasarım ile birlikte, mobil uygulamada gezinmek ve işlemleri gerçekleştirmek artık çok daha keyifli.<br/>" +
                        "📱 Güncellenen mobil uygulamamızla, her zaman en iyi deneyimi yaşamanız için çalışıyoruz.<br/>",
                    date: moment("2024-08-23").format("YYYY-MM-DD"),
                    ribbonText: "App Güncellemesi",
                    newsLink: "Yeni Mobil Uygulamayı Keşfetmek İçin Tıklayın",
                    linkText: "mobileapp",
                },
                {
                    title: "🎨 Yeni UI/UX Tasarımı 🎨",
                    ticket: "New Feature",
                    description:
                        "🎨 Mail sayfasına yanıtlanmayanlar özelliği eklendi.<br/>" +
                        "🎨 Görev raporları eklendi.<br/>" +
                        "🎨 Görev bildirimleri eklendi. <br/>" +
                        "🎨 Görev yetkileri yönetimi eklendi. <br/>" +
                        "🎨 WhatsApp şablon yönetimi eklendi. <br/>" +
                        "🎨 Holiday Plus entegrasyonu yapıldı. <br/>" +
                        "🎨 Bitrix24 entegrasyonu yapıldı. <br/>",
                    date: moment("2024-07-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "Bug Fix & Improvements 🎨",
                    ticket: "New Feature",
                    description:
                        "WhatsApp Business API optimize edildi.<br/>" +
                        "Rapor filtreleri düzeltildi.<br/>" +
                        "Arşiv filtreleri iyileştirildi.<br/>" +
                        "Chatbot mesaj hataları giderildi. <br/>" +
                        "Görev tablosu hataları düzeltildi. <br/>" +
                        "Tetikleyici hataları giderildi. <br/>" +
                        "Engelleme hataları düzeltildi.<br/>",
                    date: moment("2024-07-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "Chatbot AI  🤖",
                    ticket: "New Feature",
                    description:
                        "Chatbot’a dinleme ve ardından cevap verme özelliği eklendi. Önce kullanıcının konuşmasını dinler, sonra uygun cevabı verir.<br/>" +
                        "Yapay zekaya fonksiyon özelliği eklendi. Kendi parametrelerinizi girerek eşleme yapabilir ve uygun bilgileri alarak müşterilerinize daha iyi hizmet sunabilirsiniz.<br/>",
                    date: moment("2024-07-04").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chatbot",
                },
                {
                    title: "Bug Fix & Improvements 🎨",
                    ticket: "New Feature",
                    description:
                        "Audit logda performans düzenlendi.<br/>" +
                        "Mail sorunları giderildi.<br/>" +
                        "WhatsApp cüzdan bakiyeleri için filtreler eklendi.<br/>" +
                        "Bazı UI sorunları giderildi. <br/>" +
                        "Erken chat kapanma sorunu düzeltildi.<br/>",
                    date: moment("2024-07-04").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chatbot",
                },
                {
                    title: "🎨 Yeni UI/UX Tasarımı 🎨",
                    ticket: "New Feature",
                    description:
                        "🎨 Yenilenen arayüzümüzle, daha modern ve temiz bir görünüm sunuyoruz. Kullanıcı dostu tasarımımız sayesinde artık aradığınız bilgilere daha hızlı ve kolay ulaşabilirsiniz. <br/>" +
                        "🎨 Güncellemelerimizle, uygulamamızın performansını önemli ölçüde artırdık. Artık sayfalar daha hızlı yükleniyor ve işlemler daha akıcı bir şekilde gerçekleşiyor.<br/>" +
                        "🎨 Sizlerden gelen geri bildirimler doğrultusunda, kullanıcı deneyimini iyileştirecek yeni özellikler ekledik. Navigasyonu daha sezgisel hale getirdik ve kişiselleştirme seçeneklerini genişlettik. <br/>",
                    date: moment("2024-06-05").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "Chat Copilot Özelliği Eklendi 🫥",
                    ticket: "New Feature",
                    description:
                        "✅<b>Tonlama:</b> Chat Copilot, mesajlarınızı iletirken doğru tonu yakalamanıza yardımcı olur. Resmi, samimi veya nötr tonlarda yanıtlar oluşturabilir ve iletişiminizi daha etkili hale getirebilirsiniz.<br/>" +
                        "✅<b>Uzun Cümle Yazma:</b> Chat Copilot, yapay zeka destekli yanıtları ile sorularınızı anında cevaplar. Bu özellik, hızlı ve doğru bilgiye ulaşmanızı sağlar ve zaman kazandırır.<br/>" +
                        "✅<b>Çeviri:</b> Farklı dillerdeki kullanıcılarla kolayca iletişim kurun. Chat Copilot'un çeviri özelliği sayesinde, mesajlarınızı anında istediğiniz dile çevirebilir ve dil bariyerlerini ortadan kaldırabilirsiniz.<br/>" +
                        "✅<b>Chatbota İlet:</b> Chat Copilot, yapay zeka destekli yanıtları ile sorularınızı anında cevaplar. Bu özellik, hızlı ve doğru bilgiye ulaşmanızı sağlar ve zaman kazandırır.<br/>" +
                        "✅<b>Yapay Zeka Yanıtı:</b> Chat Copilot, mesajlarınızı iletirken doğru tonu yakalamanıza yardımcı olur. Resmi, samimi veya nötr tonlarda yanıtlar oluşturabilir ve iletişiminizi daha etkili hale getirebilirsiniz.<br/>",
                    date: moment("2024-06-05").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "Yeni özellik ve düzeltmeler 🥳",
                    ticket: "New Feature",
                    description:
                        "✅Chatbot özelliği ile, iki farklı chatbot senaryosunu birleştirerek daha kapsamlı ve entegre bir kullanıcı deneyimi sunabilirsiniz.<br/>" +
                        "✅Chatbot TimeOut bloğu ile, belirli bir süre bekledikten sonra kullanıcıya otomatik olarak mesaj göndererek işlemi sürdürme özelliği eklenmiştir.<br/>" +
                        "✅Mail entegrasyonunda tespit edilen mevcut buglar düzeltilmiştir, böylece artık e-posta gönderim işlemleri daha güvenilir ve sorunsuz bir şekilde gerçekleştirilecektir.<br/>" +
                        "✅WhatsApp'ta çift chat açılma sorunu giderilmiştir, böylece artık sohbetleriniz tek bir pencerede sorunsuz bir şekilde devam edecektir.<br/>" +
                        "✅Görev yönetim modülüne kullanıcı filtresi ve UI değişiklikleri eklenmiştir. Ayrıca, workflow yönlendirmesi ve görev öncelik belirleme özellikleri de dahil edilmiştir.<br/>" +
                        "✅Instagram yorum yönetim robotu eklenmiştir, böylece yorumlarınızı otomatik olarak yönetebilir ve daha etkili bir şekilde etkileşim sağlayabilirsiniz.<br/>",
                    date: moment("2024-06-05").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "🥳Meta Partner İş Ortaklığı🎉",
                    ticket: "New Feature",
                    description:
                        "<p>Sevgili kullanıcılarımız, heyecan verici bir gelişmeyle karşınızdayız! Artık web sitemizde Instagram entegrasyonunu tamamladık ve Messenger entegrasyonunu da unutmadık!</p><br/>" +
                        "➡️ Instagram Entegrasyonu: Kimseyle şifre paylaşmanıza gerek kalmadan hesaplarınızı güvenli bir şekilde entegre edebilir ve kullanabilirsiniz. <br/>" +
                        "➡️ Dilediğiniz sayıda sosyal medya hesabınıza bağlanarak, tek bir ekrandan yönetim sağlayabilirsiniz. <br/>" +
                        "➡️ Yapay zeka chatbot'lar ile otomatik olarak yönetim imkanından faydalanabilirsiniz. <br/>" +
                        "➡️ Supsis AI'nın tüm gelişmiş özellikleriyle uyum içinde hesaplarınızı yönetebilirsiniz. <br/>" +
                        "➡️ Messenger Entegrasyonu: Messenger entegrasyonu ile müşterilerinizle daha hızlı ve etkili bir şekilde iletişim kurabilirsiniz. <br/>" +
                        "<p>Bu yeni özelliklerle birlikte, sosyal medya varlığınızı daha etkin bir şekilde yönetebilir ve iletişiminizi güçlendirebilirsiniz.</p> <br/>",
                    date: moment("2024-05-17").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "integrations",
                },
                {
                    title: "🥳Open Ai GPT-4o Entegrasyonu🎉",
                    ticket: "New Feature",
                    description:
                        "✅ Artık Yapay zeka chatbotlarınızı daha da geliştirebilirsiniz.  <br/>" +
                        "✅ Open Ai GPT-4o entegrasyonu ile chatbotlarınızın daha akıllı ve etkili olmasını sağlayabilirsiniz.  <br/>" +
                        "✅ Chatbotlarınızın daha hızlı ve etkili bir şekilde müşterilerinizle iletişim kurmasını sağlayabilirsiniz.  <br/>" +
                        "✅ 10 Bin Adet dosya limiti ile chatbotlarınızın daha fazla veriye erişmesini sağlayabilirsiniz.  <br/>" +
                        "✅ 2 kat daha ucuz fiyatlarla chatbotlarınızı daha etkili bir şekilde yönetebilirsiniz.  <br/>",
                    date: moment("2024-05-17").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "integrations/openai",
                },
                {
                    title: "🥳Otomatik Rezervasyon Sistemi Eklendi🎉",
                    ticket: "New Feature",
                    description:
                        "➡️ İstediğiniz sayıda takvim oluşturabilirsiniz.<br/>" +
                        "➡️ Her takvim için uygun çalışma saatlerini düzenleyebilirsiniz.<br/>" +
                        "➡️ Müşterileriniz link veya platformlar aracılığıyla randevular oluşturabilir ve Chatbot ile otomatik olarak yönetebilirsiniz.<br/>" +
                        "➡️ Randevu öncesi alınacak bilgileri, dinamik formları kullanarak her dilde toplayabilirsiniz.<br/>",
                    date: moment("2024-05-17").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: `calendar/d/${moment().format("YYYY-MM-DD")}`,
                },
                {
                    title: "🎉Güncellemeler🎉",
                    ticket: "New Feature",
                    description:
                        "✅ Kişilerinizi excel'den toplu bir şekilde import edebilirsiniz.  <br/>" +
                        "✅ API veya  Toplu Mesajtan attığınız mesajları arşivde görebilirsiniz  <br/>" +
                        "✅ Fatura modeli güncellendi  <br/>" +
                        "✅ Yeni raporlar eklendi  <br/>",
                    date: moment("2024-05-17").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "visitors",
                },
                {
                    title: "🤖Chatbot Yeni Blok Eklendi 🤖",
                    ticket: "New Feature",
                    description:
                        "✅ Time Out: Bu özellik sayesinde, chatbotunuzun ne kadar süre beklemesi gerektiğini belirleyebilirsiniz. Belirlenen süre sonunda, chatbotunuzun bir temsilciye yönlendirilmesi gerekip gerekmediği ya da başka bir bloğa yönlendirilmesi gerekip gerekmediği konusunda ayarlamalar yapabilirsiniz<br/>" +
                        "✅ Rezervasyon Bloğu: Bu özellik sayesinde, chatbot otomatik olarak sizin adınıza randevu oluşturabilir. Belirlenen uygun saatler dahilinde, müşterileriniz için randevu ayarlaması yapabilir.<br/>",
                    date: moment("2024-05-17").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chatbot/stories",
                },
                {
                    title: "📅 Takvim Özelliği Eklendi",
                    ticket: "New Feature",
                    description:
                        "✅ Supsis Panelinde takvim etkinliklerinizi tutabilirsiniz..  <br/>" +
                        "✅ Temsilcilerinizin takvimlerini yönetebilirsiniz.  <br/>" +
                        "✅ Kişilere ziyaretcilere takvim etkinliği ekleyebilirsiniz.  <br/>" +
                        "✅ Gelecek takvim etkinliklerinizi takip edebilirsiniz.  <br/>",
                    date: moment("2024-03-26").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: `calendar/d/${moment().format("YYYY-MM-DD")}`,
                },
                {
                    title: "🎉 Ticimax Entegrasyonu Eklendi",
                    ticket: "New Feature",
                    description: "✅ Ticimax müşterilerinize mesaj atma otomasyonlarınızı tanımlayabilirsiniz.  <br/>",
                    date: moment("2024-03-26").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: `integrations/ticimax`,
                },
                {
                    title: "🎉Geliştirmeler🎉",
                    ticket: "Improvements",
                    description:
                        "✅ Chatbot tasarım ekranına hızlı bağlan özellliği ekledik. Dilediğiniz platforma hızlıca bağlayabilirsiniz.  <br/>" +
                        "✅ Whatsapp kişiler sayfasını güncelledik  <br/>" +
                        "✅ Artık chatbot yapay zeka asistant prompt'unu güncelleyebilirsiniz  <br/>" +
                        "✅ Dosya indirmelerinde orjinal dosya isimlerini korunuyor artık  <br/>" +
                        "✅ Chatbot dosya gönderiminde web tarafında gözükmeme sorunu giderildi  <br/>" +
                        "✅ API üzerinden broadcast mesaj atabileceğiniz geliştirmeler yapıldı  <br/>" +
                        "✅ doc.supsis.live güncellendi  <br/>",
                    date: moment("2024-03-26").format("YYYY-MM-DD"),
                },
                {
                    title: "🎉Güncellemeler🎉",
                    ticket: "New Feature",
                    description:
                        "✅ Kişilerinizi excel'den toplu bir şekilde import edebilirsiniz.  <br/>" +
                        "✅ API veya  Toplu Mesajtan attığınız mesajları arşivde görebilirsiniz  <br/>" +
                        "✅ Fatura modeli güncellendi  <br/>" +
                        "✅ Yeni raporlar eklendi  <br/>",
                    date: moment("2024-02-28").format("YYYY-MM-DD"),
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "integrations/ideasoft",
                },
                {
                    title: "🎉Yeni Entegrasyon: IDEASOFT🎉",
                    ticket: "New Feature",
                    description:
                        "👀 Ideasoft müşterilerine özel API entegrasyonu.  <br/>" +
                        "👀 Ideasoft API ile chatbotunuza yeni yetenekler katabilirsiniz.  <br/>",
                    date: moment("2024-02-28").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Entegrasyon",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "integrations/ideasoft",
                },
                {
                    title: "🔥Supsis Raporları İyileştirildi",
                    ticket: "New Feature",
                    description: "✅ Artık daha hızlı raporlar alabileceksiniz..  <br/>",
                    date: moment("2024-02-28").format("YYYY-MM-DD"),
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "settings/report-new",
                },
                {
                    title: "📣 Detaylandırılmış notification sistemi  (web,email,push) 📣",
                    ticket: "New Feature",
                    description:
                        "✅ Artık web, email ve push notificationlarınızı detaylandırabilirsiniz.  <br/>" +
                        "✅ Bildirimlerinizi özelleştirebilir ve kullanıcılarınıza daha etkili bir şekilde ulaşabilirsiniz.  <br/>",
                    date: moment("2024-02-19").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "settings/notifications",
                },
                {
                    title: "🏢 Company activities",
                    ticket: "New Feature",
                    description:
                        "✅ Supsis Panelinde Kullanıcılarınızın yaptığı aktiviteleri takip edebilirsiniz.  <br/>" +
                        "✅ Kullanıcılarınızın yaptığı aktiviteleri takip edebilir, kullanıcılarınızın performansını ölçebilirsiniz.  <br/>" +
                        "✅ Sisteme giriş yapan kullanıcılarınızın yaptığı aktiviteleri takip edebilir, kullanıcılarınızın performansını ölçebilirsiniz.  <br/>" +
                        "✅ Kullanıcılarınızın sistemi içi yaptığı değişiklikleri takip edebilirsiniz.  <br/>",
                    date: moment("2024-02-19").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "activities",
                },
                {
                    title: "🎉Modal Popup Tetikleyici🎉",
                    ticket: "New Feature",
                    description:
                        "👀 Artık web sitenizdeki ziyaretçilere modal popuplar gösterebilirsiniz.  <br/>" +
                        "👀 İstediğiniz zaman dilimlerinde, istediğiniz kullanıcılara özel modal popuplar gösterebilirsiniz.  <br/>" +
                        "👀 Modal popuplarınızı özelleştirebilir ve kullanıcılarınıza daha etkili bir şekilde ulaşabilirsiniz.  <br/>",
                    date: moment("2024-02-19").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "triggers",
                },
                {
                    title: "✨Task Geliştirmeleri ✨",
                    ticket: "New Feature",
                    description:
                        "Aktivitelerinize fotoğraf ekleyebilirsiniz. <br/>" +
                        "Faaliyetlerinizin içindeki fotoğrafları faaliyet detaylarında görebilirsiniz. <br/>" +
                        "Oluşturduğunuz İş Akışlarını silebilirsiniz. <br/>" +
                        "Artık oluşturduğunuz görevleri daha detaylı bir şekilde takip edebilirsiniz. <br/>" +
                        "Görevlerinizi özelleştirebilir ve kullanıcılarınıza daha etkili bir şekilde ulaşabilirsiniz. <br/>",
                    date: moment("2024-02-19").format("YYYY-MM-DD"),
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "tasks",
                },
                {
                    title: "✨Fail Olmayan Uzun Rapor Süresi✨",
                    ticket: "Development",
                    description:
                        "✅ Artık uzun rapor sürelerinde hata almayacaksınız.  <br/>" +
                        "✅ Uzun tarih aralıklarında rapor alabilirsiniz.  <br/>",
                    date: moment("2024-02-19").format("YYYY-MM-DD"),
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "triggers",
                },
                {
                    title: "🧾 Fatura Düzenleme",
                    ticket: "development",
                    description:
                        "Fatura Modelinde Güncellemeler yapıldı <br/>" +
                        "Kullanıcı Dönüşlerine göre fatura düzenleme yapıldı <br/>",
                    date: moment("2024-02-19").format("YYYY-MM-DD"),
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "settings/billing",
                },
                {
                    title: "🤖Chatbot Yapay Zeka ile Hızlı Senaryo Oluşturma Özelliği Eklendi 🤖",
                    ticket: "New Feature",
                    description:
                        "✅ Artık web sitenizin adresini girdiğinizde, Chatbot oluşturmak çok daha kolay. Sizin adınıza hızlıca yapay zeka senaryolarını oluşturacak bir araçla karşı karşıyasınız.  <br/>" +
                        "✅ Senaryo oluşturmadan önce, taranan verilerinizi inceleyerek gerekli düzenlemeleri yapabilirsiniz.  <br/>" +
                        "✅ Chatbot senaryonuzdaki eksik soruların cevapları, sizin yerinize yapay zeka modülü tarafından üretilsin.<br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chatbot/stories",
                },
                {
                    title: "✨Kanban Task Sistemi ✨",
                    ticket: "New Feature",
                    description:
                        "✅ Şirket içi işlerinizi ve görev yönetimini buradan takip edebilirsiniz.<br/>" +
                        "✅ Kendinize özel görev sistemi oluşturarak görev dağılımınızı yapabilirsiniz.<br/>" +
                        "✅ Buradan şirket içi işlerinizi kolayca takip edebilir ve görevlerinizi yönetebilirsiniz.<br/>" +
                        "✅ Kişiselleştirilmiş görev sistemi ile görevlerinizi düzenleyebilir ve takibinizi yapabilirsiniz.<br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "tasks",
                },
                {
                    title: "🫥Chat Copilot Özelliği Eklendi 🫥",
                    ticket: "New Feature",
                    description:
                        "Müşterilerinizle iletişim kurarken, Chat Copilot sizin için en uygun yanıtı otomatik olarak seçer.  <br/>" +
                        "Chat Copilot, müşterilerinizle iletişim kurarken size yardımcı olur.  <br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "integrations/openai",
                },
                {
                    title: "🎙️Chat Ekranı Sesi Yazıya Çevirme Özelliği Eklendi 🎙️",
                    ticket: "New Feature",
                    description: "✅ Artık chat ekranında sesli mesajları yazıya çevirebilirsiniz.  <br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chat",
                },
                {
                    title: "🤖 Chatbot Müşteri Yazdıktan Sonra Cevaplama Özelliği Eklendi 🤖",
                    ticket: "New Feature",
                    description:
                        "✅ Artık chatbot müşteri yazdıktan sonra cevap verebilir.  <br/>" +
                        "✅ Chatbotunuzun müşteri yazdıktan sonra cevap vermesini istiyorsanız, chatbot ayarlarından bu özelliği aktif edebilirsiniz.  <br/>",
                    date: moment("2024-01-18").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Denemek İçin Tıklayın",
                    linkText: "chatbot/stories",
                },
                {
                    title: "✨ Maillerinizi Artık Supsis Üzerinden Gönderebilirsiniz ✨",
                    ticket: "New Feature",
                    description:
                        "✅ Artık panel üzerinden ChatBot aracılığıyla hızlı e-posta gönderebilirsiniz.  <br/>" +
                        "✅ Chat penceresine giderek 'mail gönder' komutunu kullanarak veya ChatBot ile doğrudan iletişim kurarak, müşterilere anında özel e-postalar oluşturabilirsiniz.  <br/>" +
                        "✅ Ayrıca, kullanıcı dostu arayüzümüzde bulunan hazır şablonları kullanarak kişiselleştirilmiş mesajlarınızı kolayca oluşturabilirsiniz.  <br/>" +
                        "✅ Müşteri ismi, sipariş detayları ve diğer kişiselleştirilmiş bilgileri ekleyerek, hızla ve etkili bir şekilde özel mesajlarınızı iletebilirsiniz.  <br/>",
                    date: moment("2024-01-08").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Yeni Özelliği Keşfet",
                    linkText: "integrations/mail",
                },
                {
                    title: "🔐 Bug Fix & Improvements",
                    ticket: "New Feature",
                    description:
                        "✅ Yeni şifrenizi belirlemek için panel üzerinde bulunan kullanıcı güncelle formu kullanabilirsiniz.<br/>" +
                        "✅ Artık chat ekranında görsel mesajları kopyalayıp yapıştırabilirsiniz.<br/>" +
                        "✅ Chatbot iyileştirmeleri yapıldı.<br/>" +
                        "✅ Whatsapp Kanalı Kaldırıldı Whatsapp V1 ve V2 den devam edebilirsiniz.<br/>" +
                        "✅ Müştrei Sayfası Sorunlar Giderildi.<br/>",
                    date: moment("2024-01-08").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "🔄 Ziyaretçi Birleştirme Özelliği Eklendi",
                    ticket: "New Feature",
                    description:
                        "✅ Artık farklı kanallardan gelen ziyaretçileri birleştirebilirsiniz.<br/>" +
                        "✅ Visitor Merge özelliği sayesinde, aynı kişiye ait farklı kanallardan gelen bilgileri bir araya getirebilir, daha etkili bir müşteri yönetimi yapabilirsiniz.<br/>" +
                        "✅ Çift kayıtları birleştirmek için ziyaretçi profiline gidin ve 'Birleştir' seçeneğini kullanın.<br/>" +
                        "✅ Müşteri deneyimini artırmak ve verimliliği maksimize etmek için bu özelliği hemen kullanmaya başlayın.<br/>",
                    date: moment("2024-01-08").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "⭐️ SMS Kanalı Eklendi ⭐️",
                    ticket: "New Feature",
                    description:
                        "✅ Chat ekranından SMS gönderebilirsiniz . <br/>" +
                        "✅️ Chatbot'tan sms gönderebilirsiniz.. <br/>" +
                        "✅️ SMS ile OTP doğrulama yapabilirsiniz. <br/>",
                    date: moment("2023-12-22").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                    newsLink: "Hemen Postacell SMS Kanalını Aktif Et",
                    linkText: "integrations/sms/postacell",
                },
                {
                    title: "Bug Fix & Improvements",
                    ticket: "",
                    description:
                        "✅ Chat ekranında hatalar giderildi . <br/>" +
                        "✅️ Chat ekranında resim kopyalama özelliği eklendi.. <br/>" +
                        "✅️ Chatbot iyileştirmeleri yapıldı.. <br/>" +
                        "✅️ Chatbot dinamik filtre kıyaslama özelliği eklendi.. <br/>" +
                        "✅️ Chatbot soru validasyonları Regex ile genişletildi <br/>" +
                        "✅️ Whatsapp V1 ve V2 kanallarından gönderiken toplu mesajlar whatsapp cüzdanınıza bağlandı <br/>" +
                        "✅️ Contact List sayfasını iyileştirildi <br/>",
                    date: moment("2023-12-22").format("YYYY-MM-DD"),
                },
                {
                    title: "⭐️ Whatsapp Bakiyesi Özelliği ⭐️",
                    ticket: "New Feature",
                    description:
                        "✅ Whatsapp business ücretlerinizi artık kendi bakiyeniz ile yönetebilirsiniz . <br/>" +
                        "✅️ Toplu whatsapp mesaj gönderimleri bu bakiyeden düşecektir.. <br/>" +
                        "✅️ Düşük bakiyeniz olduğun bakiyenizi yükseltmeyi unutmayın. <br/>",
                    date: moment("2023-12-12").format("YYYY-MM-DD"),
                    ribbonText: "WA Business",
                    newsLink: "Hemen Whatsapp Bakiyesi Yükle",
                    linkText: "settings/wallet",
                },
                {
                    title: "Yeni Güncellemeler",
                    ticket: "New Feature",
                    description:
                        "✅ Fatura sayfasında gelecek ayın faturasını anlık görebilirsiniz . <br/>" +
                        "✅️ Chat ekranında görsel mesajları kopyalayıp yapıştırabilirsiniz.. <br/>",
                    date: moment("2023-12-12").format("YYYY-MM-DD"),
                },
                {
                    title: "⭐️ Mesaj Alıntılama Özelliği (Reply) ⭐️",
                    ticket: "New Feature",
                    description:
                        "⚽️ Artık ziyaretçilerinizin mesajlarını alıntılayarak cevap verebilirsiniz. <br/>" +
                        "⚽️ Alıntılanan mesajlar ziyaretçiye gönderilirken, alıntılanan mesajın altında gösterilir. <br/>" +
                        "⚽️ Alıntılanan mesajlara tıklayarak o mesaja focus olabilirsiniz. <br/>" +
                        "⚽️ Kendi mesajlarınızı alıntılayarak ziyaretçilerinize gönderebilirsiniz. <br/>" +
                        "⚽️ Herhangi bir mesaja çift tıklayarak veya sağ tık açılan menü üzerinden o mesajı alıntılayabilirsiniz. <br/>",
                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "🎉 Mesajlarda Ara Özelliği 🎉",
                    ticket: "New Feature",
                    description: "🎉️ Artık sohbet ekranında mesajlar üzerinde arama yapabilirsiniz. <br/>",
                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Yeni Özellik",
                },
                {
                    title: "🎉 Paket/Plan Yönetimi  Güncellendi 🎉",
                    ticket: "New Feature",
                    description:
                        "♦️ İstediğiniz hizmet için size uygun paketi seçip satın alabilirsiniz. <br/>" +
                        "♦️ Paketlerinizi ve ödeme bilgilerinizi yönetebilirsiniz. <br/>" +
                        "♦️ Paketlerinizi istediğiniz zaman yükseltebilir veya düşürebilirsiniz. <br/>" +
                        "♦️ Faturlarınız artık size PDF olarak hem eposta üzerinden ileteceğiz hemde panelden erişebileceksiniz. <br/>" +
                        "♦️ Paketlerinizi istediğiniz zaman iptal edebilirsiniz. <br/>",

                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Paket/Plan Yönetimi",
                },
                {
                    title: "🍄🍄 Diğer Güncellemeler 🍄🍄",
                    ticket: "New Feature",
                    description:
                        "🚨 WA Business Template Mesajlarınıza artık butonlar ekleyebilirsiniz. <br/>" +
                        "🚨 WA Business'den gönderdiğniz mesajlarınız anlık durumunu izleyebileceksiniz (iletildi,okundu,görüldü)  <br/>" +
                        "🚨 Arşivde kullanıcı bilgileri üzerinden yeni filtreler eklendi. <br/>" +
                        "🚨 Takım konuşması ve ticket bildirimler sorunları düzeltildi <br/>" +
                        "🚨 Whatsapp kanallarınızın durumları anasayfadan göreceğiniz şekilde ayarladık. <br/>",

                    date: moment("2023-11-22").format("YYYY-MM-DD"),
                    ribbonText: "Fix",
                },
                {
                    title: "🔥🔥 Akıllı Arama Çubuğu Yayında. 🔥🔥",
                    ticket: "New Feature",
                    description:
                        "📍 Kişilerini hızlıca arayıp profillerine ulaşabilirsiniz. <br/>" +
                        "📍 Sadece 'git' yazarak istedğiniz sayfaya hızlıca atlayabilirsiniz.  <br/>" +
                        "📍 Sadece 'yeni' yazarak yeni kayıt ekranlarına hızlıca erişebilirsiniz. <br/>" +
                        "📍 Command + K ile açıp kapatabilirsiniz. <br/>" +
                        "📍 Bunlarla sınırlı kalmayacak şekilde çok daha fazla aksiyonu sizler için ekleyeceğiz  <br/>",
                    date: moment("2023-11-08").format("YYYY-MM-DD"),
                },
                {
                    title: "🎉🎉 Whatsapp V2 Entegrasyonu Yayında. 🎉🎉",
                    ticket: "New Feature",
                    description:
                        "👉 Karekod V1'e göre daha stabil <br/>" +
                        "👉 V1'e göre daha hızlı <br/>" +
                        "👉 İstediğiniz numaraya hızlıca chat başlatabilirsiniz. <br/>" +
                        "👉 İstediğiniz kadar kanal açıp chatbota veya canlı desteğe yönlendirebilirsiniz <br/>" +
                        "👉 Toplu mesaj özelliğide beraberinde gelmektedir. Tadını çıkarın. <br/>" +
                        "👉 Kanallara erişim ayarları koyabilirsiniz <br/>",
                    date: moment("2023-11-07").format("YYYY-MM-DD"),
                    newsLink: "Hadi , Whatsapp Kanalı Aç...",
                    linkText: "integrations/whatsapp-v2",
                },
                {
                    title: "Güncellemeler ✅",
                    ticket: "Improvements",
                    description:
                        "👉 Chatbot profil fotosu ekleme özelliği <br/>" +
                        "👉 Takım konuşması iyileştirmeleri yapıldı <br/>" +
                        "👉 Katalog özelliği güncellendi <br/>" +
                        "👉 WA Business Template ve Toplu Mesaj özelliği eklendi <br/>" +
                        "👉 Yeni raporlar eklendi <br/>" +
                        "👉 Chatbot filtreleri iyileştirildi <br/>" +
                        "👉 Roller ve yetkiler iyileştirildi <br/>",
                    date: moment("2023-10-23").format("YYYY-MM-DD"),
                },
                {
                    title: "Yenilikler ✅ 🎉🎉",
                    ticket: "New Feature",
                    description:
                        "✅ Takım Konuşması Medya Paylaşımı ve bu medyaları kullanıcılara ve tarihe göre filtreleme seçeneği ekledi.  <br/>" +
                        "✅ Marka Sloganınızı güncelleyebilir ve tetikleyiciyi ekranda görüntüleyebilirsiniz.  <br/>" +
                        "✅ Gelişmiş chatbot raporları eklendi, artık chatbotunuzun her adımını detaylı bir şekilde takip edebilirsiniz.  <br/>" +
                        "✅ Multi WhatsApp kanallarımızla hangi departmanların görüntüleyebileceğini ve hangi kullanıcıların görmesine izin vermek istediğinizi belirleyebilirsiniz.  <br/>" +
                        "✅ Ticket özelliğini Ayarlar>Özellikler sayfasından açıp kapatabilirsiniz.  <br/>" +
                        "✅ Chatbot Segment ve etikete göre filtreleme özelliği eklendi",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-09-26").format("YYYY-MM-DD"),
                    linkText: "chat",
                },
                {
                    title: "Düzeltilen Hatalar",
                    ticket: "Bug Fix",
                    description:
                        "❗️ Kullanıcı engelleme sorunu çözüldü. Artık kullanıcı engellemek istediğinizde sorun yaşamayacaksınız.  <br/>" +
                        "❗️ Hazır içeriklerde pasif olarak seçili olan hazır içeriklerin gelme sorunu çözüldü.  <br/>" +
                        "❗️ Ticket sayfası tablo filtrelemesi düzeltildi.  <br/>" +
                        "❗️ Ticket sayfasında ticket açıldığında ticketın açıldığı yeri gösteren link düzeltildi.",
                    date: moment("2023-09-25").format("YYYY-MM-DD"),
                    newsLink: "Hadi Başlayalım...",
                    linkText: "chat",
                },
                {
                    title: "Yeni Özellik: Takım Sohbeti (Team Chat) ✅ 🎉🎉",
                    ticket: "Yeni Özellik",
                    description:
                        "Artık takım arkadaşlarınızla birebir sohbet edebilirsiniz veya departmantdaki ekip arkadaşlarınızla veya kendi belirleyeceğiniz özel gruplarla sohbet odaları oluşturabilirsiniz. Bu özellikle takımınızla iletişiminizi kolaylaştırabilir, işbirliğinizi geliştirebilir ve verimliliğinizi artırabilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-09-19").format("YYYY-MM-DD"),
                    linkText: "chat?tabIndex=6",
                },
                {
                    title: "Yeni Özellik: Multi Whatsapp Channel 🎉🎉",
                    ticket: "Yeni Özellik",
                    description:
                        "Artık birden çok Whatsapp kanalınızı tek bir hesapta yönetebilirsiniz. Bu özellikle birden fazla Whatsapp numaranızı tek bir hesapta toplayarak yönetim süreçlerinizi kolaylaştırabilir, verimliliğinizi artırabilir ve işbirliğinizi geliştirebilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Whatsapp Kanalı Eklemeyi Deneyimle...",
                    date: moment("2023-09-19").format("YYYY-MM-DD"),
                    linkText: "integrations/whatsapp-v1",
                },
                {
                    title: "İyileştirme: Otomatik Chat Atama Algoritmaları Eklendi ✅",
                    ticket: "Yeni Özellik",
                    description:
                        "Otomatik chat atama yönteminizi artık değiştirebilirsiniz. Çalışma stilinize uygun algoritmayı seçerek daha verimli bir ekip oluşturabilirsiniz.",
                    newsLink: "Chat Atama Algoritmasını Değiştir",
                    date: moment("2023-09-19").format("YYYY-MM-DD"),
                    linkText: "settings/auto-assign",
                },
                {
                    title: "Yeni Özellik: Team Chat",
                    ticket: "Yeni Özellik",
                    description:
                        "Supsis Team Chat  ile artık takım arkadaşlarınızla birebir sohbet edebilirsiniz veya departmantdaki ekip arkadaşlarınızla veya kendi belirleyeceğiniz özel gruplarla sohbet odaları oluşturabilirsiniz. Bu özellikle takımınızla iletişiminizi kolaylaştırabilir, işbirliğinizi geliştirebilir ve verimliliğinizi artırabilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-09-15").format("YYYY-MM-DD"),
                    linkText: "chat?tabIndex=6",
                    onClick: () => {
                        SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_TEAM_CHAT, {});
                    },
                },
                {
                    title: "Ziyaretci Profil Sayfası Güncellendi",
                    ticket: "UI Update",
                    description:
                        "Ziyaretci Profil Sayfası Güncellendi! Artık daha modern ve etkileşimli bir arayüzle ziyaretçi bilgilerinize kolayca erişebileceksiniz.",
                    newsLink: "Lean more...",
                    date: moment("2023-09-15").format("YYYY-MM-DD"),
                    linkText: "visitors",
                },
                {
                    title: "Yeni Entegrasyon: Whatsapp Business API",
                    ticket: "New Integration",
                    description:
                        "Whatsapp Business API ile numarınızı bize taşıyarak supsis'in tüm özelliklerinde faydanabilirsiniz. Gelen trafiğie ister canlı desteğe ister chatbot'a aktarabilirsiniz. WA Business API ile müşterilerinize kampanyan mesajları atabilirsiniz.",
                    newsLink: "Şimdi ,WA Business API'yi entegre et ...",
                    date: moment("2023-08-19").format("YYYY-MM-DD"),
                    linkText: "integrations",
                },
                {
                    title: "Webhook Entegrasyonu",
                    ticket: "Webhook",
                    description:
                        "Webhook entegrasyonu, kendi uygulamalarınızı hızlıca entegre etmenin güçlü bir yöntemidir. Webhook'lar, bir olayın gerçekleştiği anı izleyen, yakalayan ve başka bir uygulamaya anında bilgi ileten mekanizmalardır. Bu sayede veri alışverişi anında ve otomatik olarak gerçekleşir, böylece süreçlerinizi hızlandırır ve verimliliği artırır.",
                    newsLink: "Webhook Dene...",
                    date: moment("2023-08-18").format("YYYY-MM-DD"),
                    linkText: "integrations",
                },
                {
                    title: "WebChat V2 Tasarımı Yayınlandı",
                    ticket: "New Theme",
                    description:
                        "Ziyaretçi V2 Tasarımı ile yepyeni bir özellik sunuyoruz! Gelişmiş ziyaretçi takibi, anlık canlı sohbet, özelleştirilmiş mesajlar ve zengin medya paylaşımıyla müşteri deneyimini zirveye taşıyoruz. Artık web sitemize gelen her ziyaretçiyle daha kişisel ve etkileşimli bir iletişim kurabilir, satışları artırabilir ve markanızın sadık takipçi kitlesini büyütebilirsiniz. Ziyaretçi V2 Tasarımı ile işletmenizi dijital dünyada ön plana çıkarın ve rekabette bir adım öne geçin. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "V2 Tasarımını Dene...",
                    date: moment("2023-08-18").format("YYYY-MM-DD"),
                    linkText: "settings/theme-settings",
                },
                {
                    title: "Yeni Özellik: Özelleştirilebilir Profil Bilgileri (Visitor Contact Properties)",
                    ticket: "New Feature",
                    description:
                        "Ziyaretcilerinize özel profil bilgileri tanımlayarak onları daha iyi tanıyabilir ve daha kişisel bir iletişim kurabilirsiniz. Örneğin, ziyaretçilerinizin doğum tarihlerini öğrenerek onlara doğum günlerinde özel mesajlar gönderebilirsiniz. Bu özellikle ziyaretçilerinizin ilgisini çekerek markanızın sadık takipçi kitlesini büyütebilirsiniz. Daha fazla bilgi için destek ekibimize başvurun. İşlerinizde başarılar!",
                    newsLink: "Hadi Başlayalım...",
                    date: moment("2023-07-17").format("YYYY-MM-DD"),
                    linkText: "visitors",
                },
            ],
        };
    },
    methods: {
        handleCancel() {
            this.visible = false;
            localStorage.setItem("last-seen-version", this.appVersion);
        },
        checkIfNewFeatures() {
            const storedVersion = localStorage.getItem("last-seen-version");

            this.visible = storedVersion !== this.appVersion;
        },
    },
    created() {
        this.checkIfNewFeatures();
    },
};
</script>
<style lang="scss" scoped>
.news-modal-body {
    padding-right: 5px;
    overflow: auto;
    max-height: 60vh;
    overflow-x: hidden;
    overflow-y: auto;

    ::-webkit-scrollbar {
        width: 0px;
        display: none;
    }

    .new-item {
        padding: 10px;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }

        .new-item-title {
            font-weight: bold;
            font-size: 16px;

            span {
                padding: 3px 7px;
                background-color: green;
                margin-left: 5px;
                font-weight: normal;
                color: white;

                &.feature {
                    background-color: #1890ff;
                }

                &.update {
                    background-color: purple;
                }
            }
        }

        .new-item-description {
            font-size: 12px;
        }

        .new-item-date {
            font-size: 12px;
            color: #8c8c8c;
        }
    }
}

.ant-btn:hover {
    color: #faa566;
    background-color: #fff;
    border-color: #faa566;
}

.ant-btn:focus {
    color: #faa566;
    background-color: #fff;
    border-color: #faa566;
}
</style>
